NoProjects = (props) ->
  textLabel = if props.isSearchActive then 'no_projects_found' else 'no_projects'
  <div className='no-project'>{$.t "projects:welcome.#{textLabel}"}</div>

module.exports = NoProjects
